// extracted by mini-css-extract-plugin
export var blue = "_2t-f";
export var brand = "_2t-b";
export var darkGrey = "_2t-e";
export var disabled = "_2t-4";
export var disabledSubtle = "_2t-5";
export var error = "_2t-6";
export var green = "_2t-g";
export var grey = "_2t-d";
export var icon = "_2t-0";
export var inherit = "_2t-a";
export var lightGrey = "_2t-c";
export var orange = "_2t-i";
export var pink = "_2t-k";
export var primary = "_2t-1";
export var purple = "_2t-l";
export var red = "_2t-j";
export var secondary = "_2t-2";
export var success = "_2t-9";
export var tertiary = "_2t-3";
export var warning = "_2t-7";
export var warningSecondary = "_2t-8";
export var white = "_2t-m";
export var yellow = "_2t-h";